__turbopack_context__.v({
  "divider": "definition-list-module__SqasXq__divider",
  "empty": "definition-list-module__SqasXq__empty",
  "error": "definition-list-module__SqasXq__error",
  "iconButton": "definition-list-module__SqasXq__iconButton",
  "iconStatic": "definition-list-module__SqasXq__iconStatic",
  "input": "definition-list-module__SqasXq__input",
  "inputWithSuffix": "definition-list-module__SqasXq__inputWithSuffix",
  "inputWithSuffixActive": "definition-list-module__SqasXq__inputWithSuffixActive",
  "label": "definition-list-module__SqasXq__label",
  "labelCell": "definition-list-module__SqasXq__labelCell",
  "root": "definition-list-module__SqasXq__root",
  "row": "definition-list-module__SqasXq__row",
  "rowMultiline": "definition-list-module__SqasXq__rowMultiline",
  "skeletonLabel": "definition-list-module__SqasXq__skeletonLabel",
  "skeletonRow": "definition-list-module__SqasXq__skeletonRow",
  "skeletonValue": "definition-list-module__SqasXq__skeletonValue",
  "suffix": "definition-list-module__SqasXq__suffix",
  "textarea": "definition-list-module__SqasXq__textarea",
  "value": "definition-list-module__SqasXq__value",
  "valueCell": "definition-list-module__SqasXq__valueCell",
  "valueMultiline": "definition-list-module__SqasXq__valueMultiline",
  "valueWrap": "definition-list-module__SqasXq__valueWrap",
});
